import { useEffect, useState } from "react";
import { Switch, Table, message } from "antd";
import { useTranslation } from "react-i18next";
import type { UserInfo } from "@/stores/auth";
import { userService } from "@/services/user";


export function UserManagement() {
  const { t } = useTranslation("management");
  const [users, setUsers] = useState<UserInfo[]>([]);
  const [loading, setLoading] = useState(true);

  const loadUsers = async () => {
    setLoading(true);
    try {
      const data = await userService.listAll();
      setUsers(data);
    } catch {
      // Admin-only endpoint: fallback to empty
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadUsers(); }, []);

  const handleToggleAdmin = async (id: string, checked: boolean) => {
    try {
      await userService.setAdmin(id, checked);
      setUsers((prev) => prev.map((u) => u.id === id ? { ...u, is_system_admin: checked } : u));
      message.success(t("common:success"));
    } catch {
      message.error(t("common:error"));
    }
  };

  const columns = [
    { title: t("users.table.name"), dataIndex: "name", key: "name" },
    { title: t("users.table.account"), dataIndex: "account", key: "account" },
    {
      title: t("users.table.admin"), key: "admin",
      render: (_: unknown, record: UserInfo) => (
        <Switch
          checked={record.is_system_admin}
          onChange={(checked) => handleToggleAdmin(record.id, checked)}
          size="small"
        />
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={users}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 20 }}
        size="middle"
      />
    </>
  );
}
